import Image from "./Image";

export type { ImageAdapterProps } from "./Image.d";

export default Image;
